<template>
  <div class="bonus-records-container">
    <div class="page-header">
      <h2 class="page-title">我的综合素质分申请记录</h2>
      <el-button 
        type="primary" 
        icon="el-icon-refresh" 
        @click="refreshRecords"
        :loading="loading"
        class="refresh-button">
        刷新
      </el-button>
    </div>

    <div class="page-content">
      <!-- 筛选条件 -->
      <div class="filter-section">
        <el-form :inline="true" :model="filterForm" class="filter-form">
          <el-form-item label="申请状态">
            <el-select v-model="filterForm.status" placeholder="全部状态" clearable>
              <el-option label="待审核" value="待审核"></el-option>
              <el-option label="审核中" value="审核中"></el-option>
              <el-option label="已通过" value="已通过"></el-option>
              <el-option label="已拒绝" value="已拒绝"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请日期">
            <el-date-picker
              v-model="filterForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilter">查询</el-button>
            <el-button @click="resetFilter">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 申请记录表格 -->
      <el-table
        v-loading="loading"
        :data="recordsList"
        style="width: 100%"
        border
        :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '500'}"
        empty-text="暂无申请记录">
        <el-table-column
          prop="bonus_item"
          label="加分项目"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="category_name"
          label="加分类别"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="level"
          label="级别"
          width="100">
        </el-table-column>
        <el-table-column
          prop="applied_bonus_points"
          label="申请分数"
          width="100">
        </el-table-column>
        <el-table-column
          prop="real_bonus_points"
          label="实际得分"
          width="100">
          <template slot-scope="scope">
            {{ scope.row.real_bonus_points !== null ? scope.row.real_bonus_points : '待定' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="application_date"
          label="申请日期"
          width="120">
        </el-table-column>
        <el-table-column
          prop="review_status"
          label="审核状态"
          width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.review_status)">
              {{ scope.row.review_status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="viewDetail(scope.row)"
              plain>
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>

    <!-- 详情对话框 -->
    <el-dialog
      title="申请详情"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false">
      <div v-if="currentRecord" class="detail-content">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="加分项目">{{ currentRecord.bonus_item }}</el-descriptions-item>
          <el-descriptions-item label="加分类别">{{ currentRecord.category_name }}</el-descriptions-item>
          <el-descriptions-item label="级别">{{ currentRecord.level }}</el-descriptions-item>
          <el-descriptions-item label="申请分数">{{ currentRecord.applied_bonus_points }}</el-descriptions-item>
          <el-descriptions-item label="实际得分">
            {{ currentRecord.real_bonus_points !== null ? currentRecord.real_bonus_points : '待定' }}
          </el-descriptions-item>
          <el-descriptions-item label="申请日期">{{ currentRecord.application_date }}</el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <el-tag :type="getStatusType(currentRecord.review_status)">
              {{ currentRecord.review_status }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="申请理由" :span="2">
            <div class="reason-text">{{ currentRecord.reason }}</div>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 证明材料预览 -->
        <!-- <div class="attachment-section">
          <h3>证明材料</h3>
          <div class="attachment-preview">
            <div v-if="isImageFile(currentRecord.url)" class="image-preview">
              <img :src="currentRecord.url" alt="证明材料" />
            </div>
            <div v-else class="file-preview">
              <i class="el-icon-document"></i>
              <span>{{ getFileName(currentRecord.url) }}</span>
              <el-button 
                type="primary" 
                size="small" 
                @click="downloadFile(currentRecord.url)"
                plain>
                下载文件
              </el-button>
            </div>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axiosInstance from "../../api/axiosInstance";
import api from "../../api/index";

export default {
  name: 'BonusRecords',
  data() {
    return {
      api,
      loading: false,
      recordsList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      filterForm: {
        status: '',
        dateRange: []
      },
      dialogVisible: false,
      currentRecord: null
    };
  },
  created() {
    this.fetchRecords();
  },
  methods: {
    // 获取申请记录
    async fetchRecords() {
      this.loading = true;
      try {
        const params = {
          page: this.pagination.currentPage,
          page_size: this.pagination.pageSize
        };

        // 添加筛选条件
        if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
          params.start_date = this.filterForm.dateRange[0];
          params.end_date = this.filterForm.dateRange[1];
        }
        if (this.filterForm.status) {
          params.status = this.filterForm.status;
        }

        // 打印请求参数
        console.log('请求参数:', params);

        const response = await axiosInstance.get(api.getBonusApplications, { 
          params,
        });
        
        // 打印响应数据
        console.log('响应数据:', response.data);
        
        if (response.data.status === 'success') {
          this.recordsList = response.data.data.items;
          this.pagination.total = response.data.data.total;
        } else {
          this.$message.error(response.data.message || '获取申请记录失败');
        }
      } catch (error) {
        console.error('获取申请记录失败:', error);
        console.error('错误详情:', error.response ? error.response.data : error.message);
        this.$message.error('获取申请记录失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 刷新记录
    refreshRecords() {
      this.fetchRecords();
    },
    
    // 处理筛选
    handleFilter() {
      this.pagination.currentPage = 1;
      this.fetchRecords();
    },
    
    // 重置筛选
    resetFilter() {
      this.filterForm = {
        status: '',
        dateRange: []
      };
      this.pagination.currentPage = 1;
      this.fetchRecords();
    },
    
    // 处理分页变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchRecords();
    },
    
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchRecords();
    },
    
    // 查看详情
    viewDetail(row) {
      this.currentRecord = row;
      this.dialogVisible = true;
    },
    
    // 判断是否为图片文件
    isImageFile(url) {
      if (!url) return false;
      const ext = url.split('.').pop().toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext);
    },
    
    // 下载文件
    downloadFile(url) {
      if (url) {
        // 确保URL是完整的
        const fullUrl = url.startsWith('http') ? url : `${window.location.origin}${url}`;
        window.open(fullUrl);
      } else {
        this.$message.warning('没有可下载的文件');
      }
    },
    
    // 获取文件名
    getFileName(url) {
      if (!url) return '';
      return url.split('/').pop();
    },
    
    // 获取状态标签类型
    getStatusType(status) {
      const statusMap = {
        '待审核': 'info',
        '审核中': 'warning',
        '已通过': 'success',
        '已拒绝': 'danger'
      };
      return statusMap[status] || 'info';
    }
  }
};
</script>

<style scoped>
.bonus-records-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
  font-weight: 500;
}

.refresh-button {
  padding: 10px 20px;
  font-weight: 500;
}

.page-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.filter-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.detail-content {
  padding: 10px;
}

.reason-text {
  white-space: pre-line;
  line-height: 1.5;
  color: #606266;
}

.attachment-section {
  margin-top: 25px;
  border-top: 1px solid #ebeef5;
  padding-top: 20px;
}

.attachment-section h3 {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-top: 0;
  margin-bottom: 15px;
}

.attachment-preview {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
  background-color: #f9f9f9;
}

.image-preview {
  text-align: center;
}

.image-preview img {
  max-width: 100%;
  max-height: 400px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.file-preview {
  display: flex;
  align-items: center;
  padding: 10px;
}

.file-preview i {
  font-size: 24px;
  color: #909399;
  margin-right: 10px;
}

.file-preview span {
  flex: 1;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .filter-form {
    flex-direction: column;
  }
  
  .filter-form .el-form-item {
    margin-right: 0;
  }
  
  .el-dialog {
    width: 95% !important;
  }
}
</style> 